// @flow
import { Box, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import React from 'react';

import SocialIcon from '../../shared/social-icon';
import pointer from '../../../images/pointer.png';

type Props = {
  items: any,
};

const useStyles = makeStyles((theme) => ({
  social: {
    height: 'calc(95vh)',
  },
  socialSidebar: {
    height: 'calc(95vh)',
  },
  line: {
    margin: '0 auto',
    display: 'block',
    borderLeft: '2px solid white',
    height: theme.spacing(20),
  },
  link: {
    '&:hover': {
      cursor: `url(${pointer}), auto`,
    },
  },
}));

const SocialSidebar = ({ items }: Props) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      component="div"
      className={classes.socialSidebar}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <div className={classes.line} />
      <br />
      <Box
        display="flex"
        component="div"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        {items.map((social) => (
          <IconButton
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noreferer noopener"
            className={classes.link}
          >
            <SocialIcon name={social.nombre} color="white" size="1.8rem" />
          </IconButton>
        ))}
      </Box>
      <br />
      <div className={classes.line} />
    </Box>
  );
};

export default SocialSidebar;
